export default __webpack_public_path__ + "media/zurb/img/experience-design/experience_framework-3a4550364b00a206929021c414dfe73a.png";